















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'

@Component
export default class SnackBar extends Vue {
  @Prop({default: 0}) private index!: number
  @Prop({default: null}) private snackbar!: { type: string, id: string, txt: string }

  @Action('components/closeSnackbar')
  private closeSnackbar!: (id: string) => void

  get isSnackBar() {
    return this.snackbar.type && this.snackbar.type !== ''
  }

  public mounted() {
    const snack: any = document.getElementsByClassName(
      'v-snack v-snack--active v-snack--top',
    )
    snack[this.index].style.cssText = `top: ${this.index * 50}px !important`
  }

  public close() {
    this.closeSnackbar(this.snackbar.id)
  }
}
